import React from 'react';
import { connect } from 'react-redux';
import { Card } from '@drone-js/core';
import { mapStateToProps, Props } from 'component/page/search/SortAndFilter/Sidebar/SortAndFilterSidebar.selectors';
import SortAndFilterContent from 'component/page/search/SortAndFilter/SortAndFilterContent';
import SortAndFilterSidebarPlaceHolder from 'component/page/search/SortAndFilter/Sidebar/SortAndFilterSidebarPlaceHolder';
import { SortAndFilterContentVariant } from 'component/page/search/SortAndFilter/SortAndFilterContent.selectors';

const SortAndFilterSidebar: React.FC<Props> = React.memo((props) => {
    if (props.isLoading && !props.hasFilterData) {
        return <SortAndFilterSidebarPlaceHolder />;
    }

    return (
        <Card pt="16" pb="32" data-testid="activities-sort-and-filter-sidebar" variant="outlined" type="non-interactive">
            <SortAndFilterContent variant={SortAndFilterContentVariant.Sidebar} visible={true} />
        </Card>
    );
});

SortAndFilterSidebar.displayName = 'SortAndFilterSidebar';

export default connect(mapStateToProps)(SortAndFilterSidebar);
